export const list = [
    { value: "", label: "Select" },
    { value: "1", label: "Yearly" },
    { value: "2", label: "HalfYearly" },
    { value: "3", label: "Quarterly" },
    { value: "4", label: "Monthly" },
    { value: "5", label: "Fortnightly" },
    { value: "6", label: "Weekly" }
];

export const DirectDebitQuestionList = [
    {
        id: 1,
        questionLabel: "",
        questionText: "Account name",
        controlTypeId: 1,
        controlType: "Textfield",
        placeholder: "e.g. John Smith",
        questionType: "QuestionList"
    },
    {
        id: 2,
        questionLabel: "",
        questionText: "",
        controlTypeId: 15,
        controlType: "BankAccount",
        questionType: "QuestionList"
    },
    {
        id: 3,
        questionLabel: "",
        questionText: "Payment frequency",
        controlTypeId: 3,
        controlType: "Dropdown",
        placeholder: "Select",
        optionList: list,
        questionType: "QuestionList"
    }
];
